import { Home, Wand2, Users, Orbit, Workflow, Inbox, ListTodo, BarChart3, Plug, GraduationCap, Settings, UsersRound, FileText } from "lucide-react";

// New navigation per Oct 2026 spec. Underlying routes stay intact for deep-links.
// Setup & Plan   → /setup (merges /build + /your-map)
// AI Team         → /ai-team (merges /departments + /atlas + /fleet)
// Runs & Tasks    → /runs (merges /tasks + run inspection)
// Results         → /results (merges /analytics + /reports)
// Removed: /leaderboard, /digital-twin, /ops. /skills hidden. /audit moved to admin-only (public route).

export const houseNav = [
  { path: "/", label: "Overview", icon: Home },
  { path: "/setup", label: "Setup & Plan", icon: Wand2 },
  { path: "/ai-team", label: "AI Team", icon: Users },
  { path: "/map", label: "Constellation", icon: Orbit },
  { path: "/workflows", label: "Workflows", icon: Workflow },
  { path: "/runs", label: "Runs & Tasks", icon: ListTodo },
  { path: "/approvals", label: "Approvals", icon: Inbox, badge: true },
  { path: "/results", label: "Results", icon: BarChart3 },
  { path: "/connections", label: "Connections", icon: Plug },
  { path: "/academy", label: "Academy", icon: GraduationCap },
];

export const adminNav = [
  { path: "/workspaces", label: "Team", icon: UsersRound },
  { path: "/audit-log", label: "Audit Log", icon: FileText },
  { path: "/settings", label: "Settings", icon: Settings },
];

// Internal use only — legacy ops items are no longer exposed in the sidebar.
export const opsNav = [];

export const isActivePath = (pathname, path) => (path === "/" ? pathname === "/" : pathname === path || pathname.startsWith(`${path}/`));
